export const PACKAGE_NAME = 'jiraNavigationAppsSidebarNav4GrowthRecommendations';
export const TEAM_NAME = 'jira-cosmos';
export const DATA_PRIVACY_LINK = 'https://www.atlassian.com/legal/privacy-policy';
